import { render } from "./Main.vue?vue&type=template&id=365d0005"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=365d0005&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script